/* Use Shopify line keys so concurrent cart changes cannot address the wrong row. */
(() => {
  if (customElements.get('icafe-drawer-line-actions')) return;
  class ICafeDrawerLineActions extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.input = this.querySelector('input[type="number"]');
      this.addEventListener('click', event => {
        const control = event.target.closest('[name="plus"],[name="minus"],[data-cart-remove]');
        if (!control) return;
        event.preventDefault();
        if (control.disabled) return;
        const current = Number(this.dataset.quantity);
        const increment = Number(this.input.step) || 1;
        const next = control.hasAttribute('data-cart-remove') ? 0 : current + (control.name === 'plus' ? increment : -increment);
        this.update(next, control.hasAttribute('data-cart-remove') ? 'remove' : control.name);
      }, { signal });
      this.input?.addEventListener('change', () => this.update(Number(this.input.value), 'input'), { signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
    async update(quantity, controlName) {
      const drawer = this.closest('hdt-cart-drawer');
      const component = this.closest('cart-items-component');
      if (!drawer || !component || drawer.dataset.icBusy === 'true') return;
      const previous = Number(this.dataset.quantity);
      const minimum = Number(this.input.min) || 1;
      const maximum = Number(this.input.max) || Number.MAX_SAFE_INTEGER;
      if (!Number.isInteger(quantity) || (quantity !== 0 && (quantity < minimum || quantity > maximum))) {
        this.input.value = previous;
        this.showError(this.dataset.error);
        return;
      }
      if (quantity === previous) return;
      drawer.dataset.icBusy = 'true';
      component.setAttribute('aria-busy', 'true');
      component.classList.add('cart-items-disabled');
      this.querySelector('.ic-drawer-line-error').hidden = true;
      const key = this.dataset.lineKey;
      this.input.value = quantity || previous;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: [drawer.getAttribute('section-id')], sections_url: window.location.pathname.startsWith('/') ? window.location.pathname : '/' })
        });
        const cart = await response.json();
        if (!response.ok || cart.errors) {
          const errors = typeof cart.errors === 'string' ? cart.errors : Object.values(cart.errors || {}).flat().join(' ');
          throw new Error(cart.description || errors || this.dataset.error);
        }
        if (!cart.sections?.[drawer.getAttribute('section-id')]) {
          document.dispatchEvent(new CustomEvent('cart:reload'));
          return;
        }
        await new Promise(resolve => {
          const done = () => { clearTimeout(timeout); document.removeEventListener('cart:drawer:render', rendered); resolve(); };
          const rendered = () => {
            done();
            const row = [...drawer.querySelectorAll('icafe-drawer-line-actions')].find(item => item.dataset.lineKey === key);
            let target = row?.querySelector(controlName === 'input' ? 'input' : `[name="${controlName}"]`);
            if (!target || target.disabled) target = row?.querySelector('[name="plus"]') || drawer.querySelector('icafe-drawer-line-actions [name="plus"]') || drawer.querySelector('[ref="closeButton"]');
            target?.focus({ preventScroll: true });
          };
          const timeout = setTimeout(done, 4000);
          document.addEventListener('cart:drawer:render', rendered);
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: {}, sourceId: drawer.getAttribute('section-id'), cartData: cart, actionAfterATC: 'no_action', source: 'cart-items-component', data: {} }
          }));
        });
      } catch (error) {
        if (this.isConnected) {
          this.input.value = previous;
          this.showError(error.message || this.dataset.error);
        }
      } finally {
        delete drawer.dataset.icBusy;
        component.removeAttribute('aria-busy');
        component.classList.remove('cart-items-disabled');
      }
    }
    showError(message) {
      const error = this.querySelector('.ic-drawer-line-error');
      error.textContent = message;
      error.hidden = false;
    }
  }
  customElements.define('icafe-drawer-line-actions', ICafeDrawerLineActions);
})();
